import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BigButton from "../components/events/BigButton";
import EventList from "../components/events/EventList";
import { db } from "../firebase";

export default function Events({ user }) {
	const [canCreate, setCanCreate] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchUserPermissions = async () => {
			try {
				const userRef = doc(db, "users", user.uid);
				const userSnap = await getDoc(userRef);
				if (userSnap.exists()) {
					setCanCreate(userSnap.data()?.canCreate === true);
				}
			} catch (err) {
				console.error("Error fetching user permissions:", err);
			}
		};

		fetchUserPermissions();
	}, [user.uid]);

	const handleCreateClick = () => {
		if (canCreate) {
			navigate("/create-event");
		} else {
			setShowModal(true);
		}
	};

	return (
		<>
			<div className="container px-4 justify-content-center">
				<div className="col-md-8 col-lg-6 mx-auto">
					<BigButton title="Create Event" icon="bi-plus-circle" className="text-light" onClick={handleCreateClick}>
						<i className="bi bi-plus-circle me-2"></i> Create Event
					</BigButton>
				</div>
			</div>

			<EventList user={user} />

			<Modal show={showModal} onHide={() => setShowModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Want to Host Events?</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>
						<i className="bi bi-stars me-2 text-warning" style={{ fontSize: "1.5rem" }}></i>
						If you would like to create events and earn money, get in touch with us!
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowModal(false)}>
						Maybe Later
					</Button>
					<Button
						className="my-btn"
						onClick={() => {
							setShowModal(false);
							navigate("/contact");
						}}
					>
						<i className="bi bi-envelope me-2"></i>Contact Us
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
